import React, { useState } from 'react';
import { Box, Typography, Button, Divider, Snackbar, FormControlLabel, Radio, RadioGroup, TextField } from '@mui/material';
import Navbar from '../Layouts/Navbar';
import AttachMoneyIcon from "@mui/icons-material/AttachMoney";
import { Close, Edit } from '@mui/icons-material';
import MuiAlert from '@mui/material/Alert';



const inputStyle = {
    '& .MuiOutlinedInput-root': {
      height: 35,
      '&:hover fieldset': { borderColor: '#000' },
      '&.Mui-focused fieldset': { borderColor: 'red' }
    }
  };

export default function EditTarif() {


  const [formData, setFormData] = useState({
    region: 'Rabat and nearby regions',
    zone: '',
    nbrplaces: '',
    tarif: '',
    statut: "Active",
  });
  const [snack, setSnack] = useState({
    open: false,
    message: '',
    type: '',
  });

  // Handle input change
  const handleChange = (event) => {
    const { name, value } = event.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };
  

  // Snackbar handler
  const handleSnack = (message, type) => {
    setSnack({ open: true, message, type });
  };

  // Close Snackbar
  const handleCloseSnack = () => {
    setSnack({ ...snack, open: false });
  };

  // Modify handler
  const handleModify = () => {
    try {
      // Modify logic would go here
      handleSnack('Réservation modifiée avec succès', 'success');
    } catch (error) {
      handleSnack("Erreur lors de la modification de la réservation", 'error');
    }
  };

  return (
    <>
      <Navbar />
      <Box p={3}>
        <Box display="flex" justifyContent="space-between" alignItems="center" mb={2}>
          <Box display="flex" alignItems="center">
            <AttachMoneyIcon />
            <Typography variant="h6" ml={1}> EDITER UN TARIF</Typography>
          </Box>
        </Box>

        {/* Data Section */}
        <Box flex={1} pr={2}>
          <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'start' }}>
          <Typography variant="subtitle2">Région</Typography>
            <RadioGroup row name="region" value={formData.region} onChange={handleChange}>
                <FormControlLabel value="Rabat and nearby regions" control={<Radio sx={{ '&.Mui-checked': { color: '#000' } }} />} label="Rabat and nearby regions" />
                <FormControlLabel value="Kénitra & distant regions" control={<Radio sx={{ '&.Mui-checked': { color: '#000' } }} />} label="Kénitra & distant regions" />
                <FormControlLabel value="Casablanca & distant regions" control={<Radio sx={{ '&.Mui-checked': { color: '#000' } }} />} label="Casablanca & distant regions" />
                <FormControlLabel value="Agadir" control={<Radio sx={{ '&.Mui-checked': { color: '#000' } }} />} label="Agadir" />
                <FormControlLabel value="Marrakech" control={<Radio sx={{ '&.Mui-checked': { color: '#000' } }} />} label="Marrakech" />
                <FormControlLabel value="Fès" control={<Radio sx={{ '&.Mui-checked': { color: '#000' } }} />} label="Fès" />
                <FormControlLabel value="Fès Sefrou" control={<Radio sx={{ '&.Mui-checked': { color: '#000' } }} />} label="Fès Sefrou" />
            </RadioGroup>

            <Typography variant="subtitle2">Zone</Typography>
            <TextField fullWidth name="zone" value={formData.zone} onChange={handleChange} variant="outlined" sx={inputStyle} />

            <Typography variant="subtitle2">Nombre de places</Typography>
            <TextField fullWidth name="nbrplaces" value={formData.nbrplaces} onChange={handleChange} variant="outlined" sx={inputStyle} />

            <Typography variant="subtitle2">Tarif</Typography>
            <TextField fullWidth name="tarif" value={formData.tarif} onChange={handleChange} variant="outlined" sx={inputStyle} />

            <Typography variant="subtitle2">Statut</Typography>
            <RadioGroup row name="statut" value={formData.statut} onChange={handleChange}>
                <FormControlLabel value="Active" control={<Radio sx={{ '&.Mui-checked': { color: '#000' } }} />} label="Active" />
                <FormControlLabel value="Inactive" control={<Radio sx={{ '&.Mui-checked': { color: '#000' } }} />} label="Inactive" />
            </RadioGroup>

          </Box>
          <Divider sx={{ mt: 2, mb: 2, borderColor: "red", borderWidth: "1px" }} />
          <Box display="flex" gap={2}>
            <Button
              variant="outlined"
              sx={{
                color: 'red',
                borderColor: 'red',
                textTransform: 'none',
                '&:hover': { backgroundColor: 'red', color: '#fff', borderColor: 'red' },
              }}
              startIcon={<Close />}
            >
              Annuler
            </Button>
            <Button
              variant="outlined"
              sx={{
                color: 'red',
                borderColor: 'red',
                textTransform: 'none',
                '&:hover': { backgroundColor: 'red', color: '#fff', borderColor: 'red' },
              }}
              startIcon={<Edit />}
              onClick={handleModify}
            >
              Enregistrer
            </Button>
          </Box>
        </Box>
      </Box>

      {/* Snackbar */}
      <Snackbar 
        open={snack.open} 
        autoHideDuration={3000} 
        onClose={handleCloseSnack} 
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
      >
        <MuiAlert 
          onClose={handleCloseSnack} 
          severity={snack.type} 
          elevation={6} 
          variant="filled" 
          sx={{ width: '100%', bgcolor: snack.type === 'success' ? 'green' : 'red' }}
        >
          {snack.message}
        </MuiAlert>
      </Snackbar>
    </>
  );
}
